import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import Video from "../Assets/videos/newvideo.mp4";
import MobVideo from "../Assets/videos/mob-video.mp4";
import { Formik } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
export default function Home() {

  const handleAxios = async (data,resetForm) => {
    const url = process.env.REACT_APP_BASE_URL + `registerLandingPage`;
 
    const response = await axios.post(url, data);
    console.log(response,"axios");
    let payload  = response?.data
    if (payload?.success) {
      toast.success("Thank you for showing interest! You're now part of the Friz@pp community.");
    }
    if (!payload.success) {
      toast.success(payload?.message);
    }
    resetForm()
  }
  return (
    <>
      <Container fluid className="px-0">
        <div className="banner-video-sec">
          <video autoPlay muted loop playsInline>
            <source src={Video} type="video/mp4" />
            <source src={Video} type="video/ogg" />
          </video>
        </div>
        <div className="mobile-video-sec">
          <video autoPlay muted loop playsInline>
            <source src={MobVideo} type="video/mp4" />
            <source src={MobVideo} type="video/ogg" />
          </video>
        </div>
      </Container>
      <div className="gradient-sec">
        <Container className="px-0">
          <div className="bottom-form-sec">
            <h2>
              Register your interest to be the first to know about our spring
              2024 launch!
            </h2>
            <div className="form-detail">
              <h3>My Details</h3>
              <Formik
                initialValues={{
                  firstName: "",
                  surname: "",
                  phone_number: "",
                  email: "",
                  checked: false,
                }}
                validate={(values) => {
                  const errors = {};


                  if (!values.firstName) {
                    errors.firstName = "Required*";
                  }
                  if (!values.surname) {
                    errors.surname = "Required*";
                  }
                  if (!values.phone_number) {
                    errors.phone_number = "Required*";
                  }
                  if (!values.email) {
                    errors.email = "Required*";
                  } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                      values.email
                    )
                  ) {
                    errors.email = "Invalid email address";
                  }

                  if (!values.checked) {
                    errors.checked = "Required*";
                  }

                  return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  console.log(values);
                  handleAxios(values,resetForm)
                  // dispatch(userRegister(values)).then(resetForm());
                  setSubmitting(false);
                }}
              >
                {({
                  values,
                  errors,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 mb-4">
                        <input
                          type="text"
                          placeholder="First Name *"
                          name="firstName"
                          className="form-control"
                          onChange={handleChange}
                          value={values.firstName}
                        />
                        {errors.firstName && (
                          <span className="formik-errors">{errors.firstName}</span>
                        )}
                      </div>
                      <div className="col-lg-6 mb-4">
                        <input
                          type="text"
                          placeholder="Surname *"
                          name="surname"
                          className="form-control"
                          onChange={handleChange}
                          value={values.surname}
                        />
                        {errors.surname && <span className="formik-errors">{errors.surname}</span>}
                      </div>
                      <div className="col-lg-6 mb-4">
                        <input
                          type="number"
                          placeholder="Phone Number *"
                          name="phone_number"
                          className="form-control"
                          onChange={handleChange}
                          value={values.phone_number}
                        />
                        {errors.phone_number && <span className="formik-errors">{errors.phone_number}</span>}
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="email"
                          placeholder="Email *"
                          name="email"
                          className="form-control"
                          onChange={handleChange}
                          value={values.email}
                        />
                        {errors.email && <span className="formik-errors">{errors.email}</span>}
                      </div>
                      <div className="col-lg-12 d-flex justify-content-center">
                        <div className="terms_check">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="checked"
                              onChange={(e) => { setFieldValue("checked", e.target.checked) }}
                              checked={values.checked}
                            />
                            <span>
                              I accept our <Link to="">Terms of Service</Link> and
                              have read our <Link to="">Privacy Notice.</Link>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 d-flex justify-content-center">
                        <div className="register-btn">
                          <button
                            type="submit"
                            disabled={values.checked ? isSubmitting : true}
                            className={values.checked ? "lg-btn" : "lg-btn-disabled"}

                          >
                            Register
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}
